import React from 'react'

const OrderSkeleton = () => {
  return (
     <div className="bg-white rounded-2xl shadow p-4 animate-pulse flex flex-col  gap-2">
      <div className="h-8 w-full bg-gray-300 rounded-xl" />
      <div className="h-8 w-full bg-gray-300 rounded-xl" />
      <div className="h-8 w-full bg-gray-300 rounded-xl" />
      <div className="h-8 w-full bg-gray-300 rounded-xl" />
      <div className="h-8 w-full bg-gray-300 rounded-xl" />
    </div>
  )
}

export default OrderSkeleton